import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import View from '@123/druid/dist/Framework/View/View';
import type {AidenEvent} from '@Component/Aiden/Type/AidenEvent';
import ShoppingCart from '@Component/ShoppingCart/ShoppingCart';

@component
export default class AidenAdvisorView extends View {
    constructor(@inject(ShoppingCart) private readonly shoppingCart: ShoppingCart) {
        super();
    }

    protected mounted(): void {
        window.addEventListener('aiden-actions', <EventListener>((e: AidenEvent) => this.onAidenAction(e)));
    }

    private onAidenAction(event: AidenEvent): void {
        if (event.detail.actionId !== 'aiden-add-to-cart') {
            event.detail.abortCallback();
            return;
        }
        event.detail.acknowledgeCallback();
        this.onAidenAddToCart(event);
    }

    private onAidenAddToCart(event: AidenEvent): void {
        if (event.detail.products[0]) {
            this.shoppingCart
                .addProduct({productid: event.detail.products[0].id, amount: 1})
                .then(() => event.detail.successCallback())
                .catch(() => event.detail.failedCallback());
            event.stopImmediatePropagation();
        }
    }
}
